import React from 'react';
import { Form } from '../../../ui/universe';
import { Input, Tooltip } from 'tdesign-react';

/**
 * Input 参数渲染器
 * 支持通过 inputType / inputMin / inputMax 指定原生输入框类型与范围（如数字输入）
 */
function InputRenderer({ params, value, disabled, showClose, placeholder, onClose, onChange }) {
  const handleChange = (val) => {
    if (params.inputType !== 'number') {
      onChange && onChange(val);
      return;
    }
    if (val === '') {
      onChange && onChange('');
      return;
    }
    let num = Number(val);
    if (Number.isNaN(num)) return;
    if (params.inputMax !== undefined && num > params.inputMax) num = params.inputMax;
    if (params.inputMin !== undefined && num < params.inputMin) num = params.inputMin;
    onChange && onChange(num);
  };

  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={
        <>
          <span>{params.label}</span>
          {params.des && (
            <Tooltip content={params.des} theme="light">
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </>
      }
    >
      <div className="flex">
        <Input
          status={params.status}
          type={params.inputType || 'text'}
          min={params.inputMin}
          max={params.inputMax}
          value={value}
          disabled={disabled}
          onChange={handleChange}
          placeholder={params.placeholder || placeholder}
          suffix={params.unit}
        />
        {showClose && <i className="universe-icon univ-icon-close ml-10" onClick={onClose}></i>}
      </div>
      {params.tips && (
        <div style={{ marginTop: '4px', fontSize: '12px', color: '#999' }}>
          {params.tips}
        </div>
      )}
    </Form.Item>
  );
}

export default InputRenderer;
